// @flow

import React, { Component, type AbstractComponent } from 'react';
import ExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';
import PropTypes from 'prop-types';
import type AExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';

// Flow typing for the prop injected by this withExperiments HOC
export type Experiments = AExperimentsClient;

// React prop typing for the prop injected by this withExperiments HOC
export const ExperimentsPropType = PropTypes.instanceOf(ExperimentsClient);

type InjectedProps = { experiments: Experiments };

export default function legacyWithExperiments<OwnProps: InjectedProps>(
  Subject: AbstractComponent<OwnProps>,
): AbstractComponent<$Diff<OwnProps, InjectedProps>> {
  return class WithExperiments extends Component<$Diff<OwnProps, InjectedProps>> {
    // $FlowFixMe: new errors found from flow 0.96 upgrade
    static displayName = `WithExperiments(${Subject.displayName || Subject.name})`;
    static contextTypes = {
      experiments: ExperimentsPropType,
    };

    context: { experiments: Experiments };

    render() {
      return <Subject experiments={this.context.experiments} {...this.props} />;
    }
  };
}
